import {computed} from "mobx";
import {METADATA_FILTERS} from "../../../../../core/models/metatdata/metadata-filters.consts";
import {CompetitionPageMetaDataModel} from "../../../models/competition-page.meta-data.model";
import {FaqPageSchemaModel} from "../../../../../core/models/schema/faq-page-schema-model";

export class CompetitionIndexPageRouteMetaDataModel extends CompetitionPageMetaDataModel {
  @computed get pageTitle() {
    let title = this.staticTitle;

    if (this.titleSection) {
      title = this.titleSection.getElementValue(METADATA_FILTERS.COMPETITION.main)
    }

    return title
  }

  @computed get description(): String {
    let description = this.staticDescription;

    if (this.descriptionSection) {
      description = this.descriptionSection.getElementValue(METADATA_FILTERS.COMPETITION.main)
    }

    return description
  }

  get staticTitle() {
    const staticTitle = this.websiteTerms[`META_TITLE_COMPETITION_MAIN_${this.competitionId}`] || this.websiteTerms.COMPETITION_HOME_TITLE_TEMPLATE;

    return staticTitle?.format({
      COMPETITION_NAME: this.competitionName,
      SPORT_TYPE: this.competitionSportName,
      COMPETITION_HOME_TERM_IN_TITLE: this.websiteTerms.COMPETITION_HOME_TERM_IN_TITLE.format({
        "LIVESCORE_MAIN_KEYWORD": this.websiteTerms.LIVESCORE_MAIN_KEYWORD
      }),
    });
  }

  get staticDescription() {
    const description = (this.websiteTerms[`META_DESCRIPTION_COMPETITION_MAIN_${this.competitionId}`] || this.websiteTerms.COMPETITION_HOME_DESCRIPTION_TEMPLATE).format({
      "LIVESCORE_MAIN_KEYWORD": this.websiteTerms.LIVESCORE_MAIN_KEYWORD
    });

    return this.descriptionFormatTerm(description);
  }

  get dataSchemaFAQ(): FaqPageSchemaModel {
    return this.websiteModuleState.appState.appFaqDisplayModel?.hasElements ? this.schemaManager.createFAQPage(this.websiteModuleState.appState.appFaqDisplayModel?.elements) : null;
  }

}